import { makeSerializable } from "../../../utils/Utils";

class ChiefComplaintDTO {
    constructor({ QuestionId, QuestionTitle, AnswerId, AnswerValue, Responses, VoiceUrl, VoiceQuestionTitle, UserEditResponse }) {
        this.questionId = QuestionId;
        this.questionTitle = QuestionTitle;
        this.answerId = AnswerId;
        this.answerValue = AnswerValue;
        this.voiceUrl = VoiceUrl || null;
        this.voiceQuestionTitle = VoiceQuestionTitle || null;
        this.responses = Responses ? Responses.map(response => makeSerializable(new Response(response))) : [];
        this.UserEditResponse = UserEditResponse !== undefined ? UserEditResponse : true;
    }
}

class Response {
    constructor({ AnswerId, AnswerTitle, AnswerOrderId, ColorCode, ConditionalQuestionList, Title, Description, VoiceUrl, VoiceResponseTitle }) {
        this.id = AnswerId;
        this.name = AnswerTitle;
        this.answerTitle = AnswerTitle; // Keep for compatibility with edit assessment logic
        this.answerOrderId = AnswerOrderId;
        this.color = ColorCode;
        this.conditionalQuestionList = ConditionalQuestionList;
        this.title = Title;
        this.description = Description;
        this.voiceUrl = VoiceUrl || null;
        this.voiceResponseTitle = VoiceResponseTitle || null;
    }
}

export default ChiefComplaintDTO;